import { render, staticRenderFns } from "./UserViewUserPlanCard.vue?vue&type=template&id=668c281f&"
import script from "./UserViewUserPlanCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports